import type { Map as MlMap } from "maplibre-gl";

/** RainViewer radar overlay (free, off by default — SPEC §4). */
const SOURCE = "rainviewer";
const LAYER = "rainviewer-layer";
const API = "https://api.rainviewer.com/public/weather-maps.json";

interface RainViewerMaps {
  host: string;
  radar?: { past?: { time: number; path: string }[] };
}

let loaded = false;

/** Lazily add the latest radar frame as a raster layer, then toggle visibility. */
export async function setRainVisible(map: MlMap, visible: boolean): Promise<void> {
  if (visible && !loaded) {
    const res = await fetch(API, { headers: { accept: "application/json" } });
    if (!res.ok) throw new Error(`RainViewer HTTP ${res.status}`);
    const data = (await res.json()) as RainViewerMaps;
    const frames = data.radar?.past ?? [];
    const latest = frames[frames.length - 1];
    if (!latest) throw new Error("RainViewer: no radar frames");
    // {host}{path}/{size}/{z}/{x}/{y}/{color}/{options}.png  (color 2, smooth+snow)
    const tileUrl = `${data.host}${latest.path}/256/{z}/{x}/{y}/2/1_1.png`;
    map.addSource(SOURCE, { type: "raster", tiles: [tileUrl], tileSize: 256, attribution: "© RainViewer" });
    // insert below the river lines so rivers stay on top
    const before = map.getLayer("rivers-glow") ? "rivers-glow" : undefined;
    map.addLayer({ id: LAYER, type: "raster", source: SOURCE, paint: { "raster-opacity": 0.6 } }, before);
    loaded = true;
  }
  if (map.getLayer(LAYER)) {
    map.setLayoutProperty(LAYER, "visibility", visible ? "visible" : "none");
  }
}
